module.exports = __webpack_public_path__ + "static/media/icon-desktop-decorative.691c8c21.svg";